/**
 * Admin Dashboard
 * 관리자 대시보드 메인 페이지
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../use-cases';
import { PaymintStatsCard } from './PaymintStatsCard';
import { PaymintActivitiesCard } from './PaymintActivitiesCard';

export const AdminDashboard: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAdminAuth();

  useEffect(() => {
    if (!currentUser) {
      navigate('/admin/login');
      return;
    }
  }, [currentUser, navigate]);

  if (!currentUser) {
    return null;
  }

  return (
    <div className="space-y-6">
      {/* Paymint Stats & Activities */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <PaymintStatsCard />
        <PaymintActivitiesCard />
      </div>
    </div>
  );
};

export default AdminDashboard;
